import React, { useRef, useState } from "react";
import PlayGif from "./Media/play1.gif";
import PauseGif from "./Media/pause1.gif";
import AudioFile from "./Media/DayDream ft. Be.love.mp3";
import "./App.css";

const AudioPlayerButton = () => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    if (!audioRef.current) return;

    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }

    setIsPlaying(!isPlaying);
  };

  return (
    <div style={{ cursor: "pointer" }} onClick={togglePlay}>
      <img
        className="gif-img"
        src={isPlaying ? PauseGif : PlayGif}
        alt={isPlaying ? "Pause" : "Play"}
      />
      <audio ref={audioRef} src={AudioFile} />
    </div>
  );
};

export default AudioPlayerButton;
